// extracted by mini-css-extract-plugin
export default {"news":"news_news__1TA6E","title":"news_title__5osvE","image":"news_image__kiNRf"};